import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-danger",
  "use": "shield-danger-usage",
  "viewBox": "0 0 36.2 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.2 44\" id=\"shield-danger\"><title>资源 19</title><g data-name=\"图层 2\"><path d=\"M36.15 6.38h-1.79a25.5 25.5 0 0 1-8.19-1.79 38.22 38.22 0 0 1-7-3.78L18.08 0 17 .79a35.23 35.23 0 0 1-7 3.78 25.61 25.61 0 0 1-8.19 1.79L0 6.38v18.5C0 34.18 11.76 44 18.1 44s18.1-9.82 18.1-19.12zM19.43 32a1.34 1.34 0 0 1-2.67 0V12a1.34 1.34 0 0 1 2.67 0z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-danger.svg
// module id = S7i+
// module chunks = 6